import { t } from '@lingui/macro';
import { detectClient } from '@moka-fe/ats.utils';
import { MokaRequest } from 'moka-request';
import { Option } from 'moka-request/dist/types/type';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

import { ERROR_CODE_TO_MESSAGE } from './errorCode';
import { getClientLocalLang, getI18n } from '@/utils/i18n';
import { errorToast, loadingToast, successToast } from '@/utils/toast';

const i18n = getI18n();

class MageMokaRequest<T> extends MokaRequest<T> {
  constructor(url: string, options?: Option) {
    super(url, options);
    this.actionName = options?.actionName || i18n.t`操作`;
    this.query = options?.query || {};
    this.errorCodeToMessage = { ...ERROR_CODE_TO_MESSAGE, ...options?.errorCodeToMessage };
    this.init();
  }

  init = () => {
    this.addGlobalHeaders();
    this.addGlobalInterceptors();
  };

  addGlobalHeaders = () => {
    const pathname = window.location.pathname ?? '';
    const headers = [
      // 后端根据这个识别是来自MokaRequest的请求，返回约定的数据格式
      // 这个头部的命名是一个不好的例子，自定义头部应该以x开头，因为后端已经在用了，所以前端只能传这个了
      { key: 'use-http-status', value: '0' },

      // 后端根据moka-tracing 识别当前请求的语言环境等信息，主要做接口返回值的国际化
      {
        key: 'moka-tracing',
        value: JSON.stringify({
          op_no: uuidv4(),
          locale: getClientLocalLang(i18n.language),
          time_zone: `GMT${moment().format('Z')}`,
          org_id: this.query?.orgId ?? pathname.split('/')?.[2] ?? '',
          source: 'headhunter',
          fe_ver: detectClient().version,
        }),
      },
    ];
    this.globalHeaders = headers;
  };

  addGlobalInterceptors = () => {
    // apply-mobile没有toast，先保留原来的逻辑，之后替换sugar-mobile时候，需要把dispatch删掉

    this.interceptor.onSuccess = ({ actionName }) => {
      successToast(i18n._(t`${actionName}成功`));
    };
    this.interceptor.onError = ({ errorMessage, actionName }) => {
      errorToast(i18n._(t`${actionName}失败：${errorMessage || i18n._(t`未知错误`)}`));
    };
    this.interceptor.beforeRequest = ({ actionName }) => {
      loadingToast(i18n._(t`${actionName}中...`));
    };
  };
}

const mokaRequest = <T>(url: string, options?: Option) => {
  return new MageMokaRequest<T>(url, options);
};

export default mokaRequest;
